module.exports = __webpack_public_path__ + "img/profile.3ef5542c.svg";